export default "__VITE_ASSET__BOZB15oR__"